import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { base64Encode, Store } from '@softline/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  BackNavigable,
  BackNavigationService,
  SOFTLINE_FEATURE_TITLE,
  title,
  TitleStore } from '@softline/application';
import { TicketQuery } from '../../data/ticket.query';
import { SOFTLINE_FEATURE_TICKET_FILTER, TicketFilterStore } from '../../ticket.shared';
import { CommonModule } from '@angular/common';
import { translator} from '@softline/ui-core';
import { DynamicModule, WithStaticMetaForm } from '@softline/dynamic';
import { ticketQueryMeta } from '../../meta/ticket-query.meta';
import { TicketQueryService } from '../../services/ticket-query.service';

import { DateRangeFromInputComponent } from '@softline/ui-core/date';
import { DateRangeToInputComponent } from '@softline/ui-core/date';
import { InputComponent } from '@softline/ui-core';
import { NumberInputComponent } from '@softline/ui-core';
import { SelectComponent, SelectOptionDirective, SelectOptionHeaderDirective, SelectOptionSeparatorDirective } from '@softline/ui-core/combo-box';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-ticket-search',
  imports: [CommonModule, ReactiveFormsModule, DynamicModule,
    DateRangeFromInputComponent,
    DateRangeToInputComponent,
    InputComponent,
    NumberInputComponent,
    SelectComponent,
    SelectOptionDirective,
    TranslatePipe],
  templateUrl: './ticket-search.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./ticket-search.component.css'] })
export class TicketSearchComponent
  extends WithStaticMetaForm(ticketQueryMeta)
  implements OnInit, OnDestroy, BackNavigable
{
  private fb = inject(UntypedFormBuilder);
  private store = inject(Store);
  protected router = inject(Router);
  private backNavigationService = inject(BackNavigationService);
  private ticketQueryService = inject(TicketQueryService);

  readonly queryParams = this.ticketQueryService.queryParams;

  private t = translator();

  priorities: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  override form = this.fb.group({
    id: [undefined],
    description: [undefined],
    filterId: [undefined],
    from: [undefined],
    to: [undefined],
    fromPriority: [1],
    toPriority: [9] });

  private MY_TICKETS_ID = 1493;
  filters = this.store.signal(
    SOFTLINE_FEATURE_TICKET_FILTER,
    TicketFilterStore.getters.all
  );

  constructor() {
    super();
    title(this.t('#TICKETS.SEARCH.TITLE'));
  }

  override async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.backNavigationService.set(this);

    this.form.patchValue({
      id: this.queryParams()?.id,
      description: this.queryParams()?.description,
      filterId: this.queryParams()?.filterId ?? this.MY_TICKETS_ID,
      from: this.queryParams()?.from,
      to: this.queryParams()?.to,
      fromPriority: this.queryParams()?.fromPriority,
      toPriority: this.queryParams()?.toPriority });
  }

  override ngOnDestroy(): void {
    this.backNavigationService.set(undefined);
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/tickets']);
  }

  async onSubmit(query: TicketQuery): Promise<void> {
    this.router.navigate(['/ticket'], {
      queryParams: {
        query: base64Encode(JSON.stringify({ ...query })) } });
  }

  resetForm(): void {
    this.form.reset();
    this.form.patchValue({
      filterId: this.MY_TICKETS_ID });
  }
}
